export default __webpack_public_path__ + "b58bdb932791232d4df8bf0c00ea9d68.png";